import React from 'react';
import ReactView from "shared/react_view";
import AuthAlert from './../components/AuthAlert';
/*
  TODO: This file should be removed when the facebook connect app is converted to Webpacker
 */

export default class AuthAlertView extends ReactView {
  constructor(alertType, authMessage, onDeactivate, onReauthorize) {
    super(
      <AuthAlert
        alertType={alertType}
        message={authMessage}
        onDeactivate={onDeactivate}
        onReauthorize={onReauthorize}
      />
    );
  }
}
